"use strict";

const {
  Wallet,
  Signer,
  BigNumber,
  getDefaultProvider
} = require('ethers');

const {
  Web3Provider
} = require('ethers').providers;

class EnhancedWallet extends Wallet {
  constructor(privateKey, provider) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    super(privateKey, provider);
    this._options = options;

    if (options.gasPrice) {
      try {
        BigNumber.from(options.gasPrice);
      } catch (e) {
        throw Error('Invalid gasPrice option');
      }
    }

    if (options.getTransactionCount !== undefined && typeof options.getTransactionCount !== 'function') {
      throw Error('Invalid getTransactionCount option, must be a function');
    }
  }

  static createRandom() {
    return new EnhancedWallet(super.createRandom().privateKey);
  }

  connect(provider) {
    return new EnhancedWallet(this.privateKey, provider, this._options);
  }

  getGasPrice() {
    if (this._options.gasPrice === undefined) return super.getGasPrice();
    return BigNumber.from(this._options.gasPrice);
  }

  getTransactionCount() {
    if (this._options.getTransactionCount === undefined) return super.getTransactionCount(...arguments);
    return this._options.getTransactionCount(...arguments);
  }

  sendTransaction(tx) {
    let gasPrice;

    if (this._options.gasPrice !== undefined) {
      gasPrice = BigNumber.from(this._options.gasPrice).toHexString();
    }

    return super.sendTransaction({
      gasPrice,
      ...tx
    });
  }

}

class EnhancedWeb3Signer extends Signer {
  constructor() {
    super();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    const web3Provider = new Web3Provider(...args);
    this.provider = web3Provider;
  }

  getAddress() {
    return this.provider.getSigner().getAddress();
  }

  signMessage(message) {
    return this.provider.getSigner().signMessage(message);
  }

  signTypedData() {
    const signer = this.provider.getSigner(); // use experiental ether Signer._signTypedData (to remove when signTypedData is included)
    // https://docs.ethers.io/v5/api/signer/#Signer-signTypedData

    return signer._signTypedData && typeof signer._signTypedData === 'function' ? signer._signTypedData(...arguments) : signer.signTypedData(...arguments);
  }

  sendTransaction(tx) {
    return this.provider.getSigner().sendTransaction(tx);
  }

}

const getSignerFromPrivateKey = function (host, privateKey) {
  let {
    gasPrice,
    getTransactionCount,
    providers
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new EnhancedWallet(privateKey, getDefaultProvider(host, providers), {
    gasPrice,
    getTransactionCount
  });
};

module.exports = {
  EnhancedWallet,
  EnhancedWeb3Signer,
  getSignerFromPrivateKey
};